import React, { useState, useEffect } from "react";
import {
  FormControlLabel,
  Paper,
  Typography,
  useTheme,
  useMediaQuery,
  Grid,
} from "@material-ui/core";
import ActionBar from "../../common/ActionBar";
import { CheckBoxLabel, OuterContainer } from "../../EventCreation/styles";
import { Formik } from "formik";
import styled from "styled-components";
import theme from "../../../assets/theme";
import {
  CheckboxContainer,
  CustomCheckBox,
  CustomInputField,
} from "../../common/FormInputs";
import { PrimaryCTAButton, SecondaryCTAButton } from "../../common/Buttons";
import { AddCircleOutline } from "@material-ui/icons";
import { CustomRadioGroup } from "../../common/FormInputs";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import EventService from "../../../services/EventService";
import {
  getErrorMessage,
  transformPayload,
  revertPayload,
} from "../../../helpers/functions";
import { navigate } from "@reach/router";
import { ButtonContainer, FormControl } from "../FormInputs";
import _ from "lodash";

const Feedback = (id) => {
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));
  const [items, setItems] = useState([]);
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [clickedButton, setClickedButton] = useState("");

  const initialState = {
    noOfInput: "",
    type: "text",
    formField: "",
  };

  const buttons = [
    {
      label: "Text Input",
      type: "button",
      name: "text",
    },
    {
      label: "Drop Down",
      type: "button",
      name: "select",
    },
    {
      label: "Check Box",
      type: "button",
      name: "checkbox",
    },
    {
      label: "Email Id",
      type: "button",
      name: "email",
    },
    {
      label: "Radio Button",
      type: "button",
      name: "radio",
    },
  ];

  const custom_buttons = [
    {
      label: "SAVE",
      color: "default",
      primary: true,
      name: "save",
    },
    {
      label: "SAVE & NEXT",
      color: "primary",
      secondary: true,
      name: "save&next",
    },
    {
      label: "CLEAR FORM",
      color: "secondary",
      clearForm: true,
    },
  ];

  const input_one = [{ name: "label", label: "Label", type: "text" }];
  const input_two = [
    {
      name: "noOfInput",
      label: "No of Input",
      type: "text",
      inputType: "text",
    },
  ];

  const addItems = (values, setFieldValue) => {
    const new_items = [
      ...values?.items,
      {
        noOfInput: "",
        type: "text",
        formField: "",
      },
    ];
    setFieldValue("items", new_items);
  };

  const deleteItems = (index, values, setFieldValue) => {
    const new_items = [...values?.items].filter((ci, idx) => idx !== index);
    setFieldValue("items", new_items);
  };

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching event details..." });
        const response = await EventService.getEvent(id?.id, "feedback");
        setItems({
          ...response,
          feedbackForm:
            response?.feedbackForm !== null &&
            revertPayload(response?.feedbackForm),
        });
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        window.scrollTo(0, 0);
        setLoader({ state: false });
      }
    }
    if (id?.id) {
      getEventInfo();
    } else {
      window.scrollTo(0, 0);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getEventInfo() {
    try {
      setLoader({ state: true, message: "Fetching event details..." });
      const response = await EventService.getEvent(id?.id, "feedback");
      setItems({
        ...response,
        feedbackForm: revertPayload(response?.feedbackForm),
      });
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  /**
   * @description submit Feedback
   */

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const payload = {
        ...values,
        feedbackForm: values?.items.filter((item) => item.label !== "").length
          ? transformPayload(values?.items)
          : {},
      };
      delete payload.items;
      const response = await EventService.updateEvent(id?.id, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      if (clickedButton === "save") {
        getEventInfo();
      } else {
        localStorage.getItem("communicate-tab") === "true"
          ? navigate(`/dashboard/eventmanager/communicate/${id?.id}`)
          : navigate(`/dashboard/eventmanager/polling/${id?.id}`);
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "event_manager":
        navigate(`/dashboard/eventmanager/home`);
        break;
      case "email_templates":
        id?.id
          ? navigate(`/dashboard/eventmanager/email-templates/${id?.id}`)
          : navigate(`/dashboard/eventmanager/email-templates`);
        break;
      default:
        break;
    }
  };

  /**
   * @description handle button click
   */

  const handleButtonClick = (button, resetForm, handleSubmit) => {
    if (button.clearForm) {
      resetForm();
    } else {
      setClickedButton(button.name); // Store clicked button
      handleSubmit();
    }
  };

  return (
    <OuterContainer disabled={false}>
      <ActionBar
        breadcrumbs={
          id?.id
            ? [
                "Event Manager",
                "Email Templates",
                "Feedback",
                items?.eventName
                  ? `${items?.eventName} (${items?.eventDate})`
                  : "",
              ]
            : ["Event Manager", "Email Templates", "Feedback"]
        }
        {...{ onBreadcrumbClick }}
      />
      <Container>
        <Formik
          initialValues={{
            items: items?.feedbackForm?.length
              ? items?.feedbackForm?.map((item) => ({
                  ...item,
                  label: item?.label,
                  noOfInput: item?.noOfInput || "",
                  type: item?.type || "",
                  inputBox: item.inputBox || "",
                  formField: item?.formField || "",
                }))
              : [initialState] || [initialState],
          }}
          enableReinitialize
          onSubmit={onFormSubmit}
          validationSchema={""}
          validateOnBlur
          validateOnChange
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            handleChange,
            setFieldValue,
            resetForm,
          }) => (
            <FormContainer>
              <Container style={{ justifyContent: "flex-end" }}>
                <Paper elevation={3} style={{ padding: "16px" }}>
                  <Heading>Feedback</Heading>
                  {values?.items.map((arr, index) => (
                    <Paper
                      elevation={3}
                      style={{
                        padding: 16,
                        border: "1px solid #e1e3ee",
                        marginTop: "15px",
                        marginBottom: "15px",
                      }}
                    >
                      <GridLabel>Feedback Form</GridLabel>
                      <PollContainer>
                        <>
                          <GridButtons>
                            {buttons.map((button) => (
                              <PrimaryCTAButton
                                style={{
                                  marginTop: "10px",
                                  backgroundColor:
                                    arr["type"] === button.name
                                      ? "#C0DEFF"
                                      : "#e1e3ee",
                                  border: "1px solid #e1e3ee",
                                  color: "#293461",
                                }}
                                onClick={() =>
                                  setFieldValue(
                                    `items[${index}].type`,
                                    button.name,
                                  )
                                }
                              >
                                {button.label}
                              </PrimaryCTAButton>
                            ))}
                          </GridButtons>
                          <MainContainer>
                            <div>
                              {input_one.map((item, idx) => (
                                <Grid
                                  container
                                  item
                                  xs={12}
                                  spacing={3}
                                  style={{ padding: 16 }}
                                >
                                  <FormControlLabel
                                    labelPlacement="top"
                                    label={
                                      <SwitchLabel {...{ isBigScreen }}>
                                        {item.label}
                                      </SwitchLabel>
                                    }
                                    control={
                                      <CustomInputField
                                        style={{
                                          width: isBigScreen ? "250px" : "auto",
                                        }}
                                        variant="outlined"
                                        value={arr[item.name]}
                                        placeholder="Enter label"
                                        name={`items[${index}].${item.name}`}
                                        onChange={(e) =>
                                          setFieldValue(
                                            `items[${index}].${item.name}`,
                                            e.target.value,
                                          )
                                        }
                                      />
                                    }
                                  />
                                </Grid>
                              ))}
                              {["text", "email"].includes(arr["type"])
                                ? null
                                : input_two.map((item, idx) => (
                                    <Grid
                                      container
                                      item
                                      xs={12}
                                      spacing={3}
                                      style={{ padding: 16 }}
                                    >
                                      <FormControlLabel
                                        labelPlacement="top"
                                        label={
                                          <SwitchLabel {...{ isBigScreen }}>
                                            {item.label}
                                          </SwitchLabel>
                                        }
                                        control={
                                          <CustomInputField
                                            style={{
                                              width: isBigScreen
                                                ? "250px"
                                                : "auto",
                                            }}
                                            variant="outlined"
                                            value={arr[item.name]}
                                            placeholder="Enter no of inputs"
                                            name={`items[${index}].${item.name}`}
                                            onChange={(e) =>
                                              setFieldValue(
                                                `items[${index}].${item.name}`,
                                                e.target.value,
                                              )
                                            }
                                          />
                                        }
                                      />
                                    </Grid>
                                  ))}
                            </div>
                            {["text", "email"].includes(arr["type"]) ? null : (
                              <>
                                <InnerContainer>
                                  {arr["type"] === "radio" ? (
                                    <div style={{ marginTop: "5px" }}>
                                      <CustomRadioGroup
                                        radioInputs={Array.from(
                                          { length: arr["noOfInput"] },
                                          (_, index) => {
                                            const optionName = `option${
                                              index + 1
                                            }`;
                                            return {
                                              name: optionName,
                                              value: optionName,
                                              label: `Option ${index + 1}`,
                                            };
                                          },
                                        )}
                                        direction="column"
                                        value={arr["formField"]}
                                        name={`items[${index}].formField`}
                                        handleChange={handleChange}
                                        {...{ values }}
                                      />
                                    </div>
                                  ) : arr["type"] === "checkbox" ? (
                                    Array.from(
                                      { length: arr["noOfInput"] },
                                      (_, index) => {
                                        const optionName = `optionCheckbox${
                                          index + 1
                                        }`;
                                        return {
                                          name: optionName,
                                          value: optionName,
                                          label: `Option ${index + 1}`,
                                        };
                                      },
                                    ).map((item) => (
                                      <CheckboxContainer
                                        style={{ marginTop: "5px" }}
                                      >
                                        <CustomCheckBox
                                          checked={arr[item.name]}
                                          value={arr[item.name]}
                                          name={`items[${index}].${item.name}`}
                                          onChange={handleChange}
                                        />
                                        <CheckBoxLabel
                                          style={{
                                            fontFamily:
                                              theme.fonts.primaryFontSemiBold,
                                            marginRight: "5px",
                                          }}
                                        >
                                          {item.label}
                                        </CheckBoxLabel>
                                      </CheckboxContainer>
                                    ))
                                  ) : null}
                                </InnerContainer>
                                <InnerContainer
                                  style={{
                                    margin: "5px",
                                    width: isBigScreen && "35%",
                                  }}
                                >
                                  {Array.from(
                                    { length: arr["noOfInput"] },
                                    (_, index) => {
                                      const optionName = `value${index + 1}`;
                                      return {
                                        name: optionName,
                                        value: "label",
                                      };
                                    },
                                  ).map((input) => (
                                    <CustomInputField
                                      variant="outlined"
                                      type="text"
                                      style={{ marginTop: "5px" }}
                                      placeholder="Enter options"
                                      value={arr[input.name]}
                                      name={`items[${index}].${input.name}`}
                                      onChange={handleChange}
                                    />
                                  ))}
                                </InnerContainer>
                              </>
                            )}
                          </MainContainer>
                        </>
                      </PollContainer>
                      <Grid
                        item
                        xs={12}
                        style={{
                          textAlign: "left",
                          marginTop: "20px",
                        }}
                      >
                        <PrimaryCTAButton
                          style={{ width: "auto", marginLeft: 8 }}
                          onClick={() =>
                            deleteItems(index, values, setFieldValue)
                          }
                        >
                          Delete
                        </PrimaryCTAButton>
                      </Grid>
                    </Paper>
                  ))}
                  <ButtonWrapper>
                    <SecondaryCTAButton
                      onClick={() => addItems(values, setFieldValue)}
                      style={{ paddingLeft: 0 }}
                    >
                      <AddCircleOutline
                        style={{
                          marginRight: "10px",
                          marginLeft: "5px",
                        }}
                      />{" "}
                      Add More Fields
                    </SecondaryCTAButton>
                  </ButtonWrapper>
                  <FormControl>
                    <ButtonContainer>
                      {custom_buttons.map((button) => (
                        <PrimaryCTAButton
                          style={{ width: "auto", marginLeft: 8 }}
                          onClick={() =>
                            handleButtonClick(button, resetForm, handleSubmit)
                          }
                        >
                          {button.label}
                        </PrimaryCTAButton>
                      ))}
                    </ButtonContainer>
                  </FormControl>
                </Paper>
              </Container>
            </FormContainer>
          )}
        </Formik>
      </Container>
    </OuterContainer>
  );
};

export default Feedback;

const Heading = styled(Typography)(() => ({
  backgroundColor: "#00aeef",
  color: "#fff",
  padding: "8px",
  fontFamily: theme.fonts.primaryFontBold,
  borderRadius: "5px",
}));

const SwitchLabel = styled(Typography)(({ isBigScreen, width }) => ({
  width: isBigScreen ? (width ? width : "250px") : "120px",
  color: " #293461",
  fontSize: "15px",
  fontFamily: theme.fonts.primaryFontSemiBold,
}));

const FormContainer = styled.form`
  /* width: 907px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    width: 95%;
  }
`;

const GridLabel = styled(Typography)(() => ({
  width: "250px",
  color: " #00838c",
  fontSize: "15px",
  marginTop: "10px",
  marginBottom: "10px",
  marginLeft: "15px",
  fontFamily: theme.fonts.primaryFontSemiBold,
}));

const GridButtons = styled.div`
  width: auto;
  @media ${theme.breakpoints.md_up} {
    width: 20%;
  }
`;

const Container = styled.div`
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .delete {
    display: flex;
    cursor: pointer;
  }
`;

const PollContainer = styled.div`
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    display: flex;
  }
`;

const MainContainer = styled.div`
  width: 100%;
  border: 1px solid #e1e3ee;
  margin-right: 90px;
  border-radius: 10px;
  padding: 16px;
  @media ${theme?.breakpoints?.md_up} {
    display: flex;
    height: auto;
  }
`;

const InnerContainer = styled.div`
  padding-top: 18px;
`;

const ButtonWrapper = styled.div`
  width: fit-content;
  @media ${theme?.breakpoints?.md_up} {
    justify-content: flex-start;
    display: flex;
    padding-bottom: 20px;
    padding-top: 7px;
  }
`;
